
import "swiper/css";
import "./scss/main.scss";

import "./js/components/slider";

import { toggleDataActive } from "./js/utils/toggleDataActive";
import { Cart } from "./js/utils/cart";
import { moveToMouse } from "./js/utils/move-to-mouse";
import { displayAbonner } from "./js/utils/display-abonner";
import { updateMount } from "./js/components/product-variant";
import { openDropDown } from "./js/components/header";
import { openAccordion } from "./js/components/accordion";
import { formatMoney } from "./js/utils/price";

window.formatMoney = formatMoney;
document.addEventListener("DOMContentLoaded", () => {
  displayAbonner();
  const cart = new Cart();
  cart.bindClicks();
  updateMount();


  /* Module to move content with mouse */
  moveToMouse('.hero-slider_wrapper');

  /* Module to toggle dataset active with click event */
  toggleDataActive("#burger", "#menu-nav", { overlay: true });
  toggleDataActive("#close-menu", "#menu-nav", { overlay: true });
  toggleDataActive("#btn-search", "#search", { overlay: true });

  openDropDown();
  openAccordion();
});
